/** @format */

import {ReactNode, useMemo} from 'react';

import {Trans} from 'react-i18next';

import {TableFooterRow} from 'components/Table/core/components/TableFooterRow';
import {ColumnType} from 'components/Table/core/types';

import {divideBySpaces, roundFloatNumber} from 'helpers/numberHelpers';

import {CampaignStatisticsTotals} from '../../helpers/aggregateCampaignStatistics';
import {NumericText} from './styles';

interface Props {
  totals: CampaignStatisticsTotals;
  columns: ColumnType[];
}

const TotalRow = ({totals, columns}: Props) => {
  // Раунд raw → display выполняется здесь (см. TR-3, решение P3-new-1):
  // - spent → 0 знаков
  // - ctr, drr → 1 знак
  // - cpc, cpl → 0 знаков
  // - impressions, clicks, conversions, ePurchaseConversions, revenue —
  //   целочисленные в API, дополнительного округления не требуют.
  const cells = useMemo<Record<string, ReactNode>>(() => {
    const spent = roundFloatNumber(totals.spent, 0);
    const ctr = roundFloatNumber(totals.ctr, 1);
    const cpc = roundFloatNumber(totals.cpc, 0);
    const cpl = roundFloatNumber(totals.cpl, 0);
    const drr = roundFloatNumber(totals.drr, 1);

    return {
      title: <Trans>Итого</Trans>,
      // Нечисловые колонки оставляем пустыми (FR-4, UI-1).
      id: null,
      subAccount: null,
      mediaplanType: null,
      // Числовые колонки — формат через divideBySpaces (как в FormattedCell).
      spent: <NumericText>{divideBySpaces(spent)}</NumericText>,
      impressions: <NumericText>{divideBySpaces(totals.impressions)}</NumericText>,
      clicks: <NumericText>{divideBySpaces(totals.clicks)}</NumericText>,
      ctr: <NumericText>{divideBySpaces(ctr)}</NumericText>,
      cpc: <NumericText>{divideBySpaces(cpc)}</NumericText>,
      conversions: <NumericText>{divideBySpaces(totals.conversions)}</NumericText>,
      cpl: <NumericText>{divideBySpaces(cpl)}</NumericText>,
      ePurchaseConversions: (
        <NumericText>{divideBySpaces(totals.ePurchaseConversions)}</NumericText>
      ),
      revenue: <NumericText>{divideBySpaces(totals.revenue)}</NumericText>,
      drr: <NumericText>{divideBySpaces(drr)}</NumericText>,
    };
  }, [totals]);

  return <TableFooterRow columns={columns} cells={cells} />;
};

export {TotalRow};
